export default __webpack_public_path__ + "static/media/JeffMiller-min.d8561259.jpeg";